import React from 'react';
import DialogFormAction from '../FormAction/DialogFormAction';
import { useHandleClickAction } from './handlers';
import { HTMLPrinterActionProps } from './types';
import {
  ShowComponentAction,
  ShowFormAction,
  CloseDialogAction as CloseDialogActionProps,
} from '../../../services/Main/types.Component';
import DialogComponentAction from '../FormAction/DialogComponentAction';
import CloseDialogAction from '../CloseDialogAction';

export default (props: HTMLPrinterActionProps) => {
  const { action, onReactionExecute, renderAction, onClick } = props;
  const { type, label, color, icon, variant, ...rest } = action;

  const handleClickAction = useHandleClickAction({
    type,
    onReactionExecute,
    ...rest,
  });

  const handleClick = () => {
    onClick && onClick();
    handleClickAction();
  };

  if (type === 'showForm') {
    return (
      <DialogFormAction
        renderButton={renderAction}
        action={action as ShowFormAction}
      />
    );
  }

  if (type === 'closeDialog') {
    return (
      <CloseDialogAction
        action={action as CloseDialogActionProps}
        renderButton={renderAction}
      />
    );
  }

  if (type === 'showComponent') {
    return (
      <DialogComponentAction
        renderButton={renderAction}
        action={action as ShowComponentAction}
      />
    );
  }

  return renderAction({
    action,
    onClick: handleClick,
  });
};
